var _ChatAdapter_instances, _a, _ChatAdapter_MAX_SIZE, _ChatAdapter_createChatSender, _ChatAdapter_createChatMessage, _ChatAdapter_sliceLastChat;
import { __classPrivateFieldGet } from "tslib";
import { ChatSender } from '../../chat/ChatSender';
export class ChatAdapter {
    constructor() {
        _ChatAdapter_instances.add(this);
    }
    toChats(socketChats) {
        const sliced = __classPrivateFieldGet(this, _ChatAdapter_instances, "m", _ChatAdapter_sliceLastChat).call(this, socketChats);
        return sliced.map((socketChat) => this.toChat(socketChat));
    }
    toChat(socketChat) {
        return {
            sender: __classPrivateFieldGet(this, _ChatAdapter_instances, "m", _ChatAdapter_createChatSender).call(this, socketChat),
            message: __classPrivateFieldGet(this, _ChatAdapter_instances, "m", _ChatAdapter_createChatMessage).call(this, socketChat),
        };
    }
}
_a = ChatAdapter, _ChatAdapter_instances = new WeakSet(), _ChatAdapter_createChatSender = function _ChatAdapter_createChatSender(socketChat) {
    const senderType = socketChat.isMobile
        ? 'MOBILE'
        : socketChat.level === 100
            ? 'BOT'
            : 'PC';
    return new ChatSender(socketChat.icon, socketChat.nickname, senderType);
}, _ChatAdapter_createChatMessage = function _ChatAdapter_createChatMessage(socketChat) {
    return {
        type: socketChat.type,
        hash: socketChat.hash,
        timestamp: socketChat.timestamp,
        body: socketChat.msg.response,
        reactions: socketChat.reactions,
    };
}, _ChatAdapter_sliceLastChat = function _ChatAdapter_sliceLastChat(raws) {
    const length = raws.length;
    const start = Math.max(length - __classPrivateFieldGet(_a, _a, "f", _ChatAdapter_MAX_SIZE), 0);
    return raws.slice(start);
};
_ChatAdapter_MAX_SIZE = { value: 50 };
